import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import styles from "./styles.module.scss";
import COLOR_ORDINAL from "../COLOR_ORDINAL";
import Legend from "../Legend";
import formatNumber from "../../utils/formatNumber";
import ChartNote from "../ChartNote";
import STATISTIC_TYPES, { FIND_STATISTIC_TYPE_BY_VALUE } from "../STATISTIC_TYPES";
const MOCK_DATA = [
    {
        name: "鋼筋混凝土(RC)",
        data: [
            {
                name: "10~未滿20年",
                value: "351.0872",
            },
            {
                name: "30年或以上",
                value: "1444.2220",
            },
            {
                name: "1~未滿3年",
                value: "86.5928",
            },
            {
                name: "20~未滿30年",
                value: "586.7840",
            },
            {
                name: "不到1年",
                value: "20.1774",
            },
            {
                name: "5~未滿10年",
                value: "149.2194",
            },
            {
                name: "3~未滿5年",
                value: "80.9214",
            },
            {
                name: "不記得",
                value: "4.2400",
            },
        ],
    },
    {
        name: "鐵皮屋",
        data: [
            {
                name: "10~未滿20年",
                value: "18.0262",
            },
            {
                name: "30年或以上",
                value: "80.3062",
            },
            {
                name: "1~未滿3年",
                value: "5.9539",
            },
            {
                name: "20~未滿30年",
                value: "21.7174",
            },
            {
                name: "不到1年",
                value: "0.2225",
            },
            {
                name: "5~未滿10年",
                value: "9.2387",
            },
            {
                name: "3~未滿5年",
                value: "3.3413",
            },
            {
                name: "不記得",
                value: "1.7678",
            },
        ],
    },
    {
        name: "磚造、加強磚造",
        data: [
            {
                name: "10~未滿20年",
                value: "65.4410",
            },
            {
                name: "30年或以上",
                value: "310.0123",
            },
            {
                name: "1~未滿3年",
                value: "10.5859",
            },
            {
                name: "20~未滿30年",
                value: "65.7680",
            },
            {
                name: "不到1年",
                value: "5.3505",
            },
            {
                name: "5~未滿10年",
                value: "26.3083",
            },
            {
                name: "3~未滿5年",
                value: "7.4177",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
        ],
    },
    {
        name: "木造",
        data: [
            {
                name: "10~未滿20年",
                value: "5.5401",
            },
            {
                name: "30年或以上",
                value: "62.1044",
            },
            {
                name: "1~未滿3年",
                value: "1.4556",
            },
            {
                name: "20~未滿30年",
                value: "4.1422",
            },
            {
                name: "不到1年",
                value: "0.0000",
            },
            {
                name: "5~未滿10年",
                value: "2.8011",
            },
            {
                name: "3~未滿5年",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
        ],
    },
    {
        name: "其他",
        data: [
            {
                name: "10~未滿20年",
                value: "0.0000",
            },
            {
                name: "30年或以上",
                value: "9.0228",
            },
            {
                name: "1~未滿3年",
                value: "0.2353",
            },
            {
                name: "20~未滿30年",
                value: "1.5678",
            },
            {
                name: "不到1年",
                value: "0.4010",
            },
            {
                name: "5~未滿10年",
                value: "0.5445",
            },
            {
                name: "3~未滿5年",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
        ],
    },
    {
        name: "鋼構",
        data: [
            {
                name: "10~未滿20年",
                value: "13.5955",
            },
            {
                name: "30年或以上",
                value: "11.5135",
            },
            {
                name: "1~未滿3年",
                value: "0.0000",
            },
            {
                name: "20~未滿30年",
                value: "0.8599",
            },
            {
                name: "不到1年",
                value: "0.0000",
            },
            {
                name: "5~未滿10年",
                value: "2.5094",
            },
            {
                name: "3~未滿5年",
                value: "1.4094",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
        ],
    },
    {
        name: "鋼骨鋼筋混凝土(SRC)",
        data: [
            {
                name: "10~未滿20年",
                value: "0.4358",
            },
            {
                name: "30年或以上",
                value: "6.4573",
            },
            {
                name: "1~未滿3年",
                value: "1.4515",
            },
            {
                name: "20~未滿30年",
                value: "4.0264",
            },
            {
                name: "不到1年",
                value: "0.0000",
            },
            {
                name: "5~未滿10年",
                value: "0.4094",
            },
            {
                name: "3~未滿5年",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
        ],
    },
];

function MosaicChart({ data = MOCK_DATA, chartTitle, chart2Title, chart3Title, chartNote, statisticsType }) {
    const svgRef = useRef(null);
    const containerRef = useRef(null);
    const [legendItems, setLegendItems] = useState([]);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (!data || !svgRef.current) return;

        // 清除舊的圖表
        d3.select(svgRef.current).selectAll("*").remove();

        // 設定圖表尺寸和邊距
        const margin = { top: 40, right: 40, bottom: 120, left: 60 };
        const width =
            Math.min(window.innerWidth, 1440) -
            180 -
            180 -
            margin.left -
            margin.right;
        const height = 600 - margin.top - margin.bottom;

        // 創建SVG
        const svg = d3.select(svgRef.current)
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // 創建y軸比例尺
        const y = d3.scaleLinear()
            .domain([0, 100])
            .range([height, 0]);

        // 添加y軸
        const yAxis = d3.axisLeft(y)
            .ticks(5)
            .tickFormat(d => d + "%");

        svg.append("g")
            .call(yAxis)
            .call(g => g.select(".domain").remove())
            .call(g => g.selectAll(".tick line")
                .attr("x2", width)
                .attr("stroke-opacity", 0.1));

        // 重組數據結構，將建築類型作為主要分類
        const yearCategories = data.map(buildingType => {
            return {
                name: buildingType.name,
                data: buildingType.data.map(yearData => {
                    return {
                        name: yearData.name,
                        value: yearData.value
                    };
                })
            };
        });

        // 計算每個類別的總和並排序
        const sortedYearCategories = yearCategories.map(category => ({
            ...category,
            total: d3.sum(category.data, d => +d.value)
        }))
        .sort((a, b) => b.total - a.total);

        // 計算總和和比例
        const total = d3.sum(sortedYearCategories, d => d.total);
        const subCategories = Array.from(new Set(sortedYearCategories.flatMap(d => d.data.map(item => item.name))));

        // 計算每個年份區間的總和
        const mainCategoriesSum = sortedYearCategories.map(d => d.total);

        // 創建x比例尺（年份區間）
        const x = d3.scaleLinear()
            .domain([0, total])
            .range([0, width]);

        // 計算每個年份區間的起始位置
        let xAccum = 0;
        const mainCategoriesPositions = mainCategoriesSum.map(sum => {
            const pos = xAccum;
            xAccum += sum;
            return pos;
        });

        // 添加 x 軸標籤
        const xAxisLabels = svg.append("g")
            .attr("transform", `translate(0,${height + 10})`);

        const THRESHOLD_WIDTH = 60;

        // 收集所有小於等於 THRESHOLD_WIDTH 的方塊的寬度與起始位置
        const smallBlocks = [];
        sortedYearCategories.forEach((yearCategory, i) => {
            const mainCategoryWidth = x(mainCategoriesSum[i]);
            if (mainCategoryWidth <= THRESHOLD_WIDTH) {
                smallBlocks.push({
                    xStart: x(mainCategoriesPositions[i]),
                    width: mainCategoryWidth
                });
            }
        });

        // 計算小方塊區間的中央
        let smallBlocksLabelX = null;
        if (smallBlocks.length > 0) {
            const first = smallBlocks[0];
            const last = smallBlocks[smallBlocks.length - 1];
            const xStart = first.xStart;
            const xEnd = last.xStart + last.width;
            smallBlocksLabelX = xStart + (xEnd - xStart) / 2;
        }

        sortedYearCategories.forEach((yearCategory, i) => {
            const xStart = x(mainCategoriesPositions[i]);
            const mainCategoryWidth = x(mainCategoriesSum[i]);
            const xCenter = xStart + mainCategoryWidth / 2;

            // 寬度小於等於 THRESHOLD_WIDTH 的處理
            if (mainCategoryWidth <= THRESHOLD_WIDTH) {
                // 只在第一個小方塊時顯示「其餘選項...」
                if (smallBlocks.length > 0 && smallBlocks[0].xStart === xStart) {
                    xAxisLabels.append("text")
                        .attr("x", smallBlocksLabelX)
                        .attr("y", 20)
                        .attr("text-anchor", "middle")
                        .attr("font-size", "12px")
                        .attr("transform", `rotate(20, ${smallBlocksLabelX}, 0)`)
                        .text("其餘選項...");
                }
                return;
            }

            const d = yearCategory.name;
            const text = xAxisLabels.append("text")
                .attr("x", xCenter)
                .attr("y", 20)
                .attr("text-anchor", "middle")
                .attr("font-size", "12px")
                .attr("transform", `rotate(20, ${xCenter}, 0)`);

            if (!d) {
                text.text('');
                return;
            }

            if (d.length > 6) {
                const lines = [];
                for (let i = 0; i < d.length; i += 6) {
                    lines.push(d.slice(i, i + 6));
                }
                text.text("");
                lines.forEach((line, i) => {
                    text.append("tspan")
                        .text(line)
                        .attr("x", xCenter)
                        .attr("dy", i === 0 ? 0 : "1.2em");
                });
            } else {
                text.text(d);
            }
        });

        // 添加 x 軸線
        svg.append("line")
            .attr("x1", 0)
            .attr("x2", width)
            .attr("y1", height)
            .attr("y2", height)
            .attr("stroke", "#000")
            .attr("stroke-width", 1);

        // 創建顏色比例尺
        const color = d3.scaleOrdinal()
            .domain(subCategories)
            .range(COLOR_ORDINAL);

        const tooltip = d3.select(tooltipRef.current);

        // 繪製馬賽克圖
        sortedYearCategories.forEach((yearCategory, i) => {
            let yAccum = 0;
            const mainCategoryTotal = mainCategoriesSum[i];
            const xStart = x(mainCategoriesPositions[i]);
            const mainCategoryWidth = x(mainCategoriesSum[i]);

            yearCategory.data.forEach(buildingData => {
                const value = +buildingData.value;
                if (value === 0) return;

                const heightRatio = value / mainCategoryTotal;
                const rectHeight = height * heightRatio;

                svg.append("rect")
                    .attr("x", xStart)
                    .attr("y", yAccum)
                    .attr("width", mainCategoryWidth)
                    .attr("height", rectHeight)
                    .attr("fill", color(buildingData.name))
                    .attr("stroke", "white")
                    .attr("stroke-width", 1)
                    .on("mouseenter", function(event) {
                        const mousePosition = d3.mouse(this);
                        
                        const isRight = mousePosition[0] > width/2;

                        const tooltipContent = chart3Title
                            ? `${chart3Title}：${buildingData.name}\n${chart2Title}：${yearCategory.name}\n${chartTitle}的${FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).label}：${statisticsType === STATISTIC_TYPES.百分比.value ? `${Math.round(value * 100)}%` : Math.round(value)}`
                            : `${chart2Title}：${buildingData.name}\n${chartTitle}：${yearCategory.name}\n${chartTitle}的${FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).label}：${formatNumber(value, FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).value)}`;
                        
                        tooltip
                            .attr("class", `${styles.tooltip} ${isRight ? styles.tooltipShowLeft : styles.tooltipShowRight}`)
                            .style("opacity", 1)
                            .html(tooltipContent)
                            .style("left", mousePosition[0] + "px")
                            .style("top", mousePosition[1] + margin.top - 25 + "px");
                    })
                    .on("mousemove", function(event) {
                        const mousePosition = d3.mouse(this);
                        
                        const isRight = mousePosition[0] > width/2;
                        
                        tooltip
                            .attr("class", `${styles.tooltip} ${isRight ? styles.tooltipShowLeft : styles.tooltipShowRight}`)
                            .style("left", mousePosition[0] + "px")
                            .style("top", mousePosition[1] + margin.top + "px");
                    })
                    .on("mouseleave", function() {
                        tooltip.attr("class", styles.tooltip);
                    });

                const fontSize = "10px";

                if (rectHeight >= 32 && mainCategoryWidth >= THRESHOLD_WIDTH) {
                    const text = svg
                        .append("text")
                        .attr("x", xStart + mainCategoryWidth / 2)
                        .attr("y", yAccum + rectHeight / 2)
                        .attr("text-anchor", "middle")
                        .attr("dominant-baseline", "middle")
                        .attr("fill", "#fff")
                        .attr("font-size", fontSize)
                        .style("pointer-events", "none");

                    // 處理名稱文字的換行
                    const name = buildingData.name;
                    if (name.length > 5) {
                        const lines = [];
                        for (let i = 0; i < name.length; i += 5) {
                            lines.push(name.slice(i, i + 5));
                        }
                        
                        lines.forEach((line, i) => {
                            text.append('tspan')
                                .text(line)
                                .attr('x', xStart + mainCategoryWidth / 2)
                                .attr('dy', i === 0 ? '-0.6em' : '1.2em');
                        });
                    } else {
                        text.append('tspan')
                            .text(name)
                            .attr('x', xStart + mainCategoryWidth / 2)
                            .attr('dy', '-0.6em');
                    }

                    // 顯示數值
                    text.append('tspan')
                        .text(formatNumber(value, FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).value))
                        .attr('x', xStart + mainCategoryWidth / 2)
                        .attr('dy', '1.2em');
                }

                yAccum += rectHeight;
            });
        });
        
        const legendItems = subCategories.map(category => ({
            color: color(category),
            name: category,
        }));

        setLegendItems(legendItems);

    }, [data]);

    return (
        <div>
            <Legend items={legendItems} title={chart2Title} />
            <div ref={containerRef} className={styles.container}>
                <div id="tooltip" className={styles.tooltip} ref={tooltipRef}></div>
                <svg ref={svgRef}></svg>
            </div>
            {chartNote && (
                <ChartNote chartNote={chartNote} />
            )}
        </div>
    );
}

export default MosaicChart;